/*******************************************************************************
 * $Id: AccountAdminInfo.js 21307 2022-05-03 19:34:16Z sthames $ */
/**
 * @ngdoc    object
 * @module   csm.books.data
 * @name     csm.books.data.BooksData.type:AccountAdminInfo
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Account Information for Account Admin or Initial Setup. Inherits from
 * `Data.books.AccountInfo`.
 *******************************************************************************/
/* @ngInject */ export function accountAdminInfoConfig(TypeFactoryProvider) {
  /*------------------------------------------*/
  /* Using defaults rather than prototype to  */
  /* make sure default values get serialized. */
  /*------------------------------------------*/
  var defaults = {
    active: true
  };

  TypeFactoryProvider.addType({
    name: 'Data.books.accounts.AccountAdminInfo',
    inherits: 'Data.books.AccountInfo',
    $type: 'csm.booksdb.data.accounts.AccountAdminInfo, CSMBooksDBCS',
    prototype: {
      description: null, // Description.
      active: true, // Active Flag.
      required: false, // Account Type Required Flag.
      className: null, // Class Name.
      taxCategory: 0, // Account Tax Category.
      groupID: null, // Account Group ID.
      groupDescription: null // Account Group Description.
    },
    constructor: function (Data) {
      return function (data) {
        this.defaultConstructor(Object.assign({}, defaults, data));
      };
    }
  });
};
